export const SOURCE_STREAM_EXT = 'm3u8';
export const STREAM_VALID_PLAY_TYPE = 'application/vnd.apple.mpegurl';
export const PLAY_TIME_FORMAT = 'mm:ss';
export const PLAY_TIME_FORMAT_WITH_HOUR = 'HH:mm:ss';
export const PLAYBACK_RATES = [1, 1.2, 1.5, 1.7, 2];
export const OVERLAY_MESSAGE = 'Floating video active';
